import DesktopMainLayout from '../../layout/Desktop/DesktopMainLayout'
import DesktopTicketsPageLayout from '../../layout/Desktop/DesktopTicketsPageLayout';

function DesktopTicketsPage() {
  return (
    <>
      <DesktopMainLayout>
        <DesktopTicketsPageLayout />
      </DesktopMainLayout>
    </>
  )
}

export default DesktopTicketsPage
